// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export const MIN_PASSWORD_LENGTH = 6;

export type PasswordFormError = 'currentRequired' | 'tooShort' | 'mismatch';

type PasswordFormInput = {
  requireCurrent: boolean;
  currentPassword: string;
  newPassword: string;
  repeatPassword: string;
};

// Passwords are deliberately never trimmed: leading/trailing spaces are valid characters.
export const validatePasswordForm = ({
  requireCurrent,
  currentPassword,
  newPassword,
  repeatPassword,
}: PasswordFormInput): PasswordFormError | null => {
  if (requireCurrent && currentPassword.length === 0) return 'currentRequired';
  if (newPassword.length < MIN_PASSWORD_LENGTH) return 'tooShort';
  if (newPassword !== repeatPassword) return 'mismatch';
  return null;
};
